import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X, User, LogOut, LayoutDashboard } from 'lucide-react';

export const Navigation = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="backdrop-blur-md bg-white/80 border-b border-border/40 sticky top-0 z-50">
      <div className="px-6 md:px-12 lg:px-24 py-6">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img 
              src="/logo.png" 
              alt="Just Inn Diam" 
              className="h-12 md:h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/catalog" className="font-body text-sm uppercase tracking-widest hover:text-primary transition-colors" data-testid="nav-catalog">
              Catalog
            </Link>
            {isAuthenticated ? (
              <>
                <Link 
                  to={user?.role === 'admin' ? '/admin' : '/dashboard'} 
                  className="font-body text-sm uppercase tracking-widest hover:text-primary transition-colors flex items-center gap-2"
                  data-testid="nav-dashboard"
                >
                  <LayoutDashboard size={16} />
                  {user?.role === 'admin' ? 'Admin' : 'Dashboard'}
                </Link>
                <button
                  onClick={handleLogout}
                  className="font-body text-sm uppercase tracking-widest hover:text-primary transition-colors flex items-center gap-2"
                  data-testid="nav-logout-btn"
                >
                  <LogOut size={16} />
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="font-body text-sm uppercase tracking-widest hover:text-primary transition-colors" data-testid="nav-login">
                  Login
                </Link>
                <Link 
                  to="/register" 
                  className="bg-primary text-white hover:bg-primary/90 uppercase tracking-widest text-xs font-bold px-6 py-3 transition-all duration-300"
                  data-testid="nav-register-btn"
                >
                  Register
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-6 space-y-4 pb-4" data-testid="mobile-menu">
            <Link to="/catalog" className="block font-body text-sm uppercase tracking-widest hover:text-primary transition-colors">
              Catalog
            </Link>
            {isAuthenticated ? (
              <>
                <Link to={user?.role === 'admin' ? '/admin' : '/dashboard'} className="block font-body text-sm uppercase tracking-widest hover:text-primary transition-colors">
                  {user?.role === 'admin' ? 'Admin Dashboard' : 'Dashboard'}
                </Link>
                <button onClick={handleLogout} className="block font-body text-sm uppercase tracking-widest hover:text-primary transition-colors">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="block font-body text-sm uppercase tracking-widest hover:text-primary transition-colors">
                  Login
                </Link>
                <Link to="/register" className="block font-body text-sm uppercase tracking-widest hover:text-primary transition-colors">
                  Register
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};